<template>
  <div>
    <EquipmentEditHeader v-if="isAdmin" data-cy="equipment-edit-header" />
    <EquipmentTable
      data-cy="equipment-table"
      @select="$emit('select', $event.data as Cables)"
    />
  </div>
</template>

<script setup lang="ts">
import { useCables } from "@/composables/equipment/cables/cables";
import { provide } from "vue";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { Cables } from "gql/api";
const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (e: "select", equipment: Cables): void;
}>();

const cableSearch = useCables(props.isAdmin);

provide("equipment", cableSearch);
</script>
